var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { addLegacyProjectionFix } from './legacyProjections';
export const LOOKUP_SERVICE_PROD = 'https://lookup.previews.cimpress.io';
export const LOOKUP_SERVICE_DEV = 'https://int.lookup.previews.cimpress.io';
export const LOOKUP_SERVICE_LOCAL = 'http://localhost:3000';
// Convert all values in object to string
export function stringifyAttributes(attributes) {
  return JSON.stringify(attributes, (_, v) => v && typeof v === 'object' ? v : '' + v);
}
// Queries the lookup API for a list of views
export function getViews(_ref) {
  let {
    authorizationHeader,
    request,
    environment = 'prod'
  } = _ref;
  return __awaiter(this, void 0, void 0, function* () {
    const isValid = validParams(authorizationHeader, request);
    if (isValid.error) {
      throw new Error(isValid.error);
    }
    const host = environment === 'int' ? LOOKUP_SERVICE_DEV : LOOKUP_SERVICE_PROD;
    const params = new URLSearchParams();
    // Reference data
    params.set('referenceId', request.reference.id);
    if (request.reference.version) {
      params.set('referenceVersion', request.reference.version.toString());
    }
    params.set('attributes', stringifyAttributes(request.reference.attributes));
    params.set('tenant', JSON.stringify(request.tenant));
    if (request.purpose) {
      params.set('purpose', request.purpose);
    }
    if (request.subPurpose) {
      params.set('subPurpose', request.subPurpose);
    }
    if (request.previewType) {
      params.set('previewTypes', JSON.stringify(request.previewType));
    }
    if (request.debug) {
      params.set('debug', 'true');
    }
    const requestUrl = "".concat(host, "/api/v2/views?").concat(params.toString());
    const response = yield fetch(requestUrl, {
      headers: new Headers({
        authorization: authorizationHeader
      })
    });
    if (!response.ok) {
      throw Error("Lookup API returned status code ".concat(response.status));
    }
    const json = yield response.json();
    return addLegacyProjectionFix(json.views);
  });
}
export function validParams(authorizationHeader, request) {
  if (!authorizationHeader) {
    return {
      error: 'accessToken was not found, accessToken is required'
    };
  }
  if (!request) {
    return {
      error: 'request was not found, request is required'
    };
  }
  if (request && (!request.reference || !request.reference.attributes || !request.reference.id)) {
    return {
      error: 'request was found, but it is invalid. One of these is invalid (id, attributes)'
    };
  }
  return {
    success: true,
    error: null
  };
}